import React, { Component } from 'react';

class TranscribingDocumentation extends Component {
    render() {
        return (
            <div>
              <p>
                Transcribing a sample analyzes it and reads the notes
                information for that sample. It then creates a
                new <b>External Instrument</b> track with  the notes from 
                that sample. 
              </p>
              <p>
                To transcribe a sample, go to the <b>Piano Roll</b> for that
                track, and then click the <b>Transcribe</b> button.
              </p>
              <p>
                Zequencer uses a machine-learing algorithm developed by 
                Google's <a href="https://magenta.tensorflow.org/">Magenta team</a> to 
                transcribe samples. You can read about
                it <a href="https://magenta.tensorflow.org/onsets-frame">here</a>.
              </p>
            </div>
        );
    }
}

export default TranscribingDocumentation;
